// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseCircleFilledSvg from "@fishx/icons-svg/es/asn/CloseCircleFilled";
import FishxIcon from '../components/FishxIcon';

var CloseCircleFilled = function CloseCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleFilledSvg
  }));
};

CloseCircleFilled.displayName = 'CloseCircleFilled';
export default React.forwardRef(CloseCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloseCircleFilled.js
// module id = 2234
// module chunks = 0